import * as Linking from 'expo-linking';
import { Platform } from 'react-native';
import { SUPPORT_EMAIL } from '@shared/support';
import { customerPortalBaseUrl } from './customerPortalUrl';

const portalOrigin = customerPortalBaseUrl();

/** URL canónica HTTPS de la política (por defecto: portal + /privacidad). */
export const privacyPolicyUrl = process.env.EXPO_PUBLIC_PRIVACY_POLICY_URL ?? `${portalOrigin}/privacidad`;

/** URL canónica HTTPS de los términos (por defecto: portal + /terminos). */
export const termsOfServiceUrl = process.env.EXPO_PUBLIC_TERMS_URL ?? `${portalOrigin}/terminos`;

/** Correo de soporte (override opcional por entorno). */
export const supportEmail = process.env.EXPO_PUBLIC_SUPPORT_EMAIL ?? SUPPORT_EMAIL;

export async function openLegalUrl(kind: 'privacy' | 'terms'): Promise<void> {
  const url = kind === 'privacy' ? privacyPolicyUrl : termsOfServiceUrl;
  if (Platform.OS === 'web') {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  const supported = await Linking.canOpenURL(url);
  if (supported) {
    await Linking.openURL(url);
  }
}

/** Página pública con instrucciones para borrar cuenta sin app. */
export const accountDeletionHelpUrl = `${portalOrigin}/cuenta/eliminar`;
